module.exports = __webpack_public_path__ + "img/mobile-background.1aa69ba.jpg";